/**
 * @file index.tsx
 *
 * @fileoverview Renders a custom highlight job icon (not used by default as its null).
 */

import { Job } from '~/jobiqo/types/types';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { BadgeIcon } from '~/vcl/icons/Badge';

interface JobHighlightJobIconSlotProps {
  /**
   * The job to render the icon for.
   */
  job: Slottable<Job>;
  /**
   * The width of the icon.
   */
  width?: string;
  /**
   * The height of the icon.
   */
  height?: string;
}

export default function JobHighlightJobIconSlot({
  job,
  width,
  height,
}: JobHighlightJobIconSlotProps) {
  return (
    <BadgeIcon {...(width ? { width } : {})} {...(height ? { height } : {})} />
  );
}
export { JobHighlightJobIconSlot };
